import React from "react";
import { Grid, Typography } from "@sumprio/ui";

interface EmptyStateContentProps {
  title: string;
  description: string;
}

export default function EmptyStateContent({ title, description }: EmptyStateContentProps) {
  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="sm"
      style={{ maxWidth: 440, width: "100%", textAlign: "center" }}
    >
      <Typography variant="heading" headingSize="xs" headingWeight="medium">
        {title}
      </Typography>
      <Typography variant="body" bodySize="sm" bodyWeight="regular" color="gray">
        {description}
      </Typography>
    </Grid>
  );
}
